export default __webpack_public_path__ + "static/albert-einstein-d3c39483039db2585f89bc949e4e2ada.png";